export default __webpack_public_path__ + "156b72467bb54b6de1d03e73363503b3.wav";